export const ProductCategoryMap = {
    1: { 'icon': '/images/SKUCategories/orthopaedic.png', 'name': 'Orthopaedic', 'cid': 1 },
    2: { 'icon': '/images/SKUCategories/oral_care.png', 'name': 'Oral Care', 'cid': 2 },
    3: {'icon': '/images/SKUCategories/sexual_wellness.png', 'name': 'Sexual Wellness', 'cid': 3},
    4: {'icon': '/images/SKUCategories/self_wellfare.png', 'name': 'Self Wellness', 'cid': 4},
    101: {
        'icon': '/images/SKUCategories/handwash_sanitizer.png', 'name': 'Handwash & Sanitizer',
        'cid': 101
    },
    102: {
        'icon': '/images/SKUCategories/healthcare_devices.png', 'name': 'Healthcare Devices',
        'cid': 102
    },
    103: {
        'icon': '/images/SKUCategories/sanitary_pads.png', 'name': 'Sanitary Pads',
        'cid': 103
    },
    104: { 'icon': '/images/SKUCategories/baby_food.png', 'name': 'Baby Food', 'cid': 104 },
    105: { 'icon': '/images/SKUCategories/first_aid.png', 'name': 'First Aid', 'cid': 105 },
    106: {
        'icon': '/images/SKUCategories/nutritional_drinks.png', 'name': 'Nutritional Drinks', 'cid': 106
    },
    107: {
        'icon': '/images/SKUCategories/face_wash_scrub.png', 'name': 'Facewash & Scrub', 'cid': 107
    },
    108: {
        'icon': '/images/SKUCategories/sunscreen_moisturizers.png', 'name': 'Sunscreen & Moisturizers', 'cid': 108
    },
    111: {
        'icon': '/images/SKUCategories/haircare_supplements.png', 'name': 'Haircare & Supplements',
        'cid': 111
    },
    112: {
        'icon': '/images/SKUCategories/birth_control.png', 'name': 'Birth Control & Monitoring',
        'cid': 112
    }, 113: {
        'icon': '/images/SKUCategories/summer_solutions.png', 'name': 'Summer Solutions', 'cid': 113
    },
    114: {
        'icon': '/images/SKUCategories/diabetes_care.png', 'name': 'Diabetes Care',
        'cid': 114
    },
    115: {
        'icon': '/images/SKUCategories/pain_relief.png', 'name': 'Pain Relief',
        'cid': 115
    },
    116: {
        'icon': '/images/SKUCategories/acidity_digestion.png', 'name': 'Acidity & Digestion',
        'cid': 116
    },
    117: {
        'icon': '/images/SKUCategories/disinfectants_cleaners.png', 'name': 'Disinfectants Cleaners',
        'cid': 117
    },
    129: {
        'icon': '/images/SKUCategories/diaper_pants_wipes.png', 'name': 'Diaper Pants & Wipes',
        'cid': 129
    },
    131: {
        'icon': '/images/SKUCategories/ayurveda.png', 'name': 'Ayurveda',
        'cid': 131
    },
    132: {
        'icon': '/images/SKUCategories/baby_healthcare.png', 'name': 'Baby Healthcare',
        'cid': 132
    },
    135: {
        'icon': '/images/SKUCategories/insects_repellents.png', 'name': 'Insects Repellents',
        'cid': 135
    },
}

export const SubCategoriesMap = {
    1: [{ 'icon': '', 'name': 'Support Braces', 'cid': 110, '_pid': 1 }],
    2: [{ 'icon': '', 'name': 'Toothpastes', 'cid': 121, '_pid': 2 },
    { 'icon': '', 'name': 'Dental Cream', 'cid': 122, '_pid': 2 },
    { 'icon': '', 'name': 'Tooth Powder', 'cid': 123, '_pid': 2 },
    { 'icon': '', 'name': 'Toothbrushes', 'cid': 124, '_pid': 2 },
    { 'icon': '', 'name': 'Mouthwashes', 'cid': 125, '_pid': 2 },
    { 'icon': '', 'name': 'Flosses Tongue Cleaner', 'cid': 126, '_pid': 2 },
    { 'icon': '', 'name': 'Oral Gels', 'cid': 127, '_pid': 2 },
    { 'icon': '', 'name': 'Oral Supplements', 'cid': 128, '_pid': 2 }],
    3: [
        { 'icon': '', 'name': 'Condoms', 'cid': 118, '_pid': 3 },
        { 'icon': '', 'name': 'Lubricants Gels', 'cid': 119, '_pid': 3 },
        { 'icon': '', 'name': 'Men Performance', 'cid': 120, '_pid': 3 },
        { 'icon': '', 'name': 'Women Performance', 'cid': 133, '_pid': 3 },
    ],
    4: [
        {'icon': '', 'name': 'Women Care', 'cid': 130, '_pid': 4},
        {'icon': '', 'name': 'Men Care', 'cid': 134, '_pid': 4}    
    ]
}